export default (to) => { return to.matched.some((record) => record.meta.requiresAuth); };
